import React from "react";
import Sidebar from "../../menu/Sidebar";
import Topbar from "../../menu/Topbar";
import Api from "../../Services/Api";
import RealgemsSidebar from "../../realgems/RealgemsSidebar";
import "./MachinesSupport.css";

const MachinesSupport = ({ audience = "LICENSED", realgems = false }) => {
  const [menuClose, setMenuClose] = React.useState(false);
  const [machines, setMachines] = React.useState([]);
  const [loading, setLoading] = React.useState(true);

  const toggleMenu = () => {
    setMenuClose((prev) => !prev);
  };

  React.useEffect(() => {
    let mounted = true;

    const loadMachines = async () => {
      try {
        setLoading(true);
        const response = await Api.get("/public/machine-videos", {
          params: { audience },
        });
        const items = Array.isArray(response?.data?.items) ? response.data.items : [];

        if (!mounted) return;
        setMachines(items);
      } catch (err) {
        console.error("Erro ao carregar máquinas de apoio:", err);

        if (!mounted) return;
        setMachines([]);
      } finally {
        if (mounted) {
          setLoading(false);
        }
      }
    };

    loadMachines();

    return () => {
      mounted = false;
    };
  }, [audience]);

  return (
    <div className="app-container">
      {realgems ? (
        <RealgemsSidebar close={menuClose} machinesSupportActive="active" />
      ) : (
        <Sidebar close={menuClose} machinesSupportActive="active" />
      )}

      <main className="main-content">
        <Topbar page="Máquinas" onToggleMenu={toggleMenu} />

        <section className="machines-support-card">
          <div className="machines-support-header">
            <div>
              <h1 className="machines-support-title">Máquinas</h1>
              <p className="machines-support-description">
                Confira os materiais de apoio disponíveis para cada máquina, com descrição do
                produto e links úteis como vídeo, manual e conteúdos complementares.
              </p>
            </div>
          </div>

          {loading ? (
            <div className="machines-support-empty-state">Carregando materiais de apoio...</div>
          ) : machines.length ? (
            <div className="machines-support-grid">
              {machines.map((machine) => (
                <article className="machine-support-item" key={machine.id}>
                  <div className="machine-support-item-image">
                    {machine.imageUrl ? (
                      <img src={machine.imageUrl} alt={machine.title} />
                    ) : (
                      <div className="machine-support-item-placeholder">Sem foto</div>
                    )}
                  </div>

                  <div className="machine-support-item-body">
                    <div className="machine-support-item-copy">
                      <h2>{machine.title || "Máquina sem nome"}</h2>
                      <p>{machine.description || "Descrição não informada."}</p>
                    </div>

                    <div className="machine-support-item-links">
                      {(machine.links || []).map((link) => (
                        <a key={link.id} href={link.url} target="_blank" rel="noreferrer">
                          {link.label}
                        </a>
                      ))}
                    </div>
                  </div>
                </article>
              ))}
            </div>
          ) : (
            <div className="machines-support-empty-state">
              Nenhuma máquina foi configurada no momento. Procure o super administrador.
            </div>
          )}
        </section>
      </main>
    </div>
  );
};

export default MachinesSupport;
